import header from "./couple-managing-budget-together-kitchen.jpg";
import section1 from "./closeup-couple-holding-hands-house-key.webp";
import section2 from "./businessman-checking-documents.jpg";
import section3 from "./board-with-sold-lettering.jpg";
import section4 from "./concentrated-mature-couple-with-bills.jpg";
import section5 from "./female-hand-operating-calculator.jpg";
import section6 from "./businessman-giving-house-key-customer.jpg";
import section7 from "./top-view-hands-stationery-items.jpg";
import section8 from "./cute-real-estate-agent-with-sold-panel.jpg";
import section9 from "./essecke-eines-hauses.jpg";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
  section8,
  section9,
};
